import { Component, inject, signal, TemplateRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgTemplateOutlet, NgComponentOutlet } from '@angular/common';
import { MainHeaderComponent } from '../../../shared/ui/layout/main-header/main-header.component';
import { LayoutService } from '../../services/layout.service';
import { MobileNavMenuComponent } from '../../../shared/ui/layout/mobile-nav-menu/mobile-nav-menu.component';
import { TabletSidebarComponent } from '../../../shared/ui/layout/tablet-sidebar/tablet-sidebar.component';
import { PageContextService } from '../../services/page-context.service';
import { ButtonComponent } from '../../../shared/ui/button/button.component';
import { AsideService } from '../../services/aside.service';
import { SheetComponent } from '../../../shared/ui/sheet/sheet.component';
import { AsideContentComponent } from '../../../shared/ui/layout/aside-content/aside-content.component';
import { AssistantWidgetComponent } from '../../../shared/ui/assistant/assistant-widget.component';
import { FeatureFlagService } from '../../services/feature-flag.service';
import { ToastComponent } from '../../../shared/ui/toast/toast.component';

@Component({
  selector: 'app-tablet-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    MainHeaderComponent,
    MobileNavMenuComponent,
    TabletSidebarComponent,
    NgTemplateOutlet,
    NgComponentOutlet,
    ButtonComponent,
    SheetComponent,
    AsideContentComponent,
    ToastComponent,
    AssistantWidgetComponent,
  ],
  templateUrl: './tablet-layout.component.html',
  styleUrl: './tablet-layout.component.css',
})
export class TabletLayoutComponent {
  protected readonly featureFlags = inject(FeatureFlagService);
  protected layoutService = inject(LayoutService);
  protected pageContextService = inject(PageContextService);
  protected asideService = inject(AsideService);
  protected headerVisible = signal(true);
  private lastScrollTop = 0;
  private readonly SCROLL_THRESHOLD = 10; // Min scroll distance to trigger change

  /**
   * Handles scroll events on the main content area to show/hide the main header.
   */
  onContentScroll(event: Event): void {
    const target = event.target as HTMLElement;
    const scrollTop = target.scrollTop;

    // Ignore small scroll movements to prevent jitter
    if (Math.abs(scrollTop - this.lastScrollTop) <= this.SCROLL_THRESHOLD) {
      return;
    }

    // Hide header when scrolling down, show when scrolling up
    if (scrollTop > this.lastScrollTop && scrollTop > 64) {
      // 64 is header height
      this.headerVisible.set(false);
    } else {
      this.headerVisible.set(true);
    }

    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
  }

  isTemplateRef(content: any): content is TemplateRef<any> {
    return content instanceof TemplateRef;
  }
}
